import { useEffect } from 'react';
import { useApolloClient } from '@apollo/client';
import PropTypes from 'prop-types';
import FavMealDetailsQuery from './FavMealDetailsQuery';

const FavMealDetailsCacheConnectorApollo = ({ children }) => {
  const client = useApolloClient();
  const requestIdleCallbackIds = [];

  useEffect(() => {
    return () => {
      if (window.cancelIdleCallback) {
        requestIdleCallbackIds.forEach((id) => {
          window.cancelIdleCallback(id);
        });
      }
    };
  }, []);

  const idle = (callback) => {
    if (!window.requestIdleCallback) {
      callback();
      return;
    }
    requestIdleCallbackIds.push(window.requestIdleCallback(callback));
  };

  const createFetch = (mealId) => {
    idle(() =>
      client.query({
        query: FavMealDetailsQuery,
        variables: {
          mealId,
        },
      })
    );
  };

  return children({
    prefetchMealDetails: createFetch,
  });
};

FavMealDetailsCacheConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default FavMealDetailsCacheConnectorApollo;
